import api from "./api";

class NotificacaoService {
  /**
   * Lista notificações não lidas do usuário
   */
  async listarNaoLidas() {
    try {
      // O interceptor do axios já retorna response.data automaticamente
      const data = await api.get("/notificacoes");
      return data || [];
    } catch (error) {
      console.error("Erro ao listar notificações:", error);
      return []; // Retorna array vazio em caso de erro
    }
  }

  /**
   * Conta notificações não lidas do usuário
   */
  async contarNaoLidas() {
    try {
      // O interceptor do axios já retorna response.data automaticamente
      const data = await api.get("/notificacoes/contador");
      return {
        total:
          typeof data?.total === "number"
            ? data.total
            : typeof data?.count === "number"
              ? data.count
              : 0,
        notificacoes:
          typeof data?.notificacoes === "number"
            ? data.notificacoes
            : typeof data?.count === "number"
              ? data.count
              : 0,
        tarefas: typeof data?.tarefas === "number" ? data.tarefas : 0,
      };
    } catch (error) {
      console.error("Erro ao contar notificações:", error);
      return {
        total: 0,
        notificacoes: 0,
        tarefas: 0,
      }; // Retorna zero em caso de erro ao invés de lançar exceção
    }
  }

  /**
   * Marca uma notificação como lida
   */
  async marcarComoLida(id) {
    try {
      // O interceptor do axios já retorna response.data automaticamente
      const data = await api.put(`/notificacoes/${id}/lida`);
      return data;
    } catch (error) {
      console.error("Erro ao marcar notificação como lida:", error);
      throw error;
    }
  }

  /**
   * Marca todas as notificações como lidas
   */
  async marcarTodasComoLidas() {
    try {
      // O interceptor do axios já retorna response.data automaticamente
      const data = await api.put("/notificacoes/marcar-todas-lidas");
      return data;
    } catch (error) {
      console.error("Erro ao marcar todas as notificações como lidas:", error);
      throw error;
    }
  }

  /**
   * Busca uma notificação específica por ID
   */
  async buscarPorId(id) {
    try {
      // O interceptor do axios já retorna response.data automaticamente
      const data = await api.get(`/notificacoes/${id}`);
      return data;
    } catch (error) {
      console.error("Erro ao buscar notificação:", error);
      throw error;
    }
  }
}

export default new NotificacaoService();
